import React from "react";
import Bar from '../JSX/Bar';
import Footer from '../JSX/Footer';

const Consulting = () => {
  return (
        <div>
        <Bar/>
        <section id="services" className="services">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2>Consulting Services</h2>
          <h2>
            The site provides advisory services to avoid new and inexperienced investors from falling into investment and legal problems,</h2>
            <h2>in addition to the investor's communication with legal and economic advisors in advanced cases. The Telegram bot has been relied upon to create the autoresponder.</h2>
        </div>

        <div class="elfsight-app-b348c7da-cd11-4929-b702-ccb8decfe143"></div>
        
          {/* End Service Item */}

      </div>

    </section>

        <Footer/>
        </div>
  );
};

export default Consulting;